import React from 'react';
import { Outlet } from 'react-router-dom';
import T from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './LayoutWrapper.module.scss';

const cx = classnames.bind(styles);

const LayoutWrapper = ({ overlay = 'default' }) => {
  return (
    <div className={cx('container', `container--${overlay}`)}>
      <div className={cx('content-wrapper')}>
        <Outlet />
      </div>
    </div>
  );
};

LayoutWrapper.propTypes = {
  overlay: T.string,
};

export default LayoutWrapper;
